import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IncidentFormControls } from 'src/app/types';

@Component({
  selector: 'app-review-form-value-additional-stolen-items',
  templateUrl: './review-form-value-additional-stolen-items.component.html',
  styleUrl: './review-form-value-additional-stolen-items.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormValueAdditionalStolenItemsComponent {
  public form = input.required<FormGroup<IncidentFormControls>>();
}
